<template>
  <tx-autocomplete
    :model-value="modelValue" :label="label" :placeholder="placeholder" :errors="errors"
    :fetch-suggestions="searchArticleNumber" value-prop="ArticleNumber" display-prop="ArticleNumber" :required="required"
    :disabled="disabled" :clearable="clearable" @update:model-value="onModelValueUpdated"
  />
</template>

<script setup lang="ts">
import type { ErrorObject } from '@vuelidate/core'
import TxAutocomplete from './TxAutocomplete.vue'
import utils from '@/services/utils'
import { useUserStore } from '@/store/userData'
import { getArticleFilterValues } from '@/api/t1/article'
import type { ArticleFilterModel } from '@/api/t1/model/articleModel'
import { FilterCriteriaMode } from '@/models/filterCriteria'

interface IProps {
  modelValue?: string | number | null
  errors?: ErrorObject[]
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  clearable?: boolean
  skippedArticleIds?: number[]
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: null,
  label: '',
  placeholder: '',
  required: false,
  clearable: false,
  disabled: false,
  errors: () => [] as ErrorObject[],
  skippedArticleIds: () => [] as number[],
})

const emit = defineEmits<{
  (e: 'update:modelValue', val: string | number | null): void
}>()

const userStore = useUserStore()

function searchArticleNumber(query: string, callback) {
  if (userStore.activeCatalog) {
    const filters: ArticleFilterModel[] = []
    if (utils.isDefined(query)) {
      filters.push({ attribute: 'ArticleNumber', mode: FilterCriteriaMode.startWithString, value: query.trim(), exclude: false })
    }

    getArticleFilterValues(userStore.activeCatalog.CatalogCode, { attributes: ['ArticleNumber'], filters, skippedArticleIds: props.skippedArticleIds, sortCriteria: { attribute: 'ArticleNumber', isAsc: true } }, 200)
      .then((data) => {
        callback(data)
      })
  }
  else {
    callback([])
  }
}

function onModelValueUpdated(val?: string | number) {
  emit('update:modelValue', val || null)
}
</script>
